import type React from 'react';
import { createContext, useContext, useRef, useState } from 'react';

interface RewriteButtonContextType {
  activeFieldId: string | null;
  setActiveField: (fieldId: string | null) => void;
  registerField: (fieldId: string) => void;
  unregisterField: (fieldId: string) => void;
}

const RewriteButtonContext = createContext<RewriteButtonContextType | undefined>(undefined);

export const RewriteButtonProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeFieldId, setActiveFieldId] = useState<string | null>(null);
  const registeredFields = useRef<Set<string>>(new Set());

  const registerField = (fieldId: string) => {
    registeredFields.current.add(fieldId);
  };

  const unregisterField = (fieldId: string) => {
    registeredFields.current.delete(fieldId);
    if (activeFieldId === fieldId) {
      setActiveFieldId(null);
    }
  };

  const setActiveField = (fieldId: string | null) => {
    // 最後にホバーした要素を優先
    setActiveFieldId(fieldId);
  };

  return (
    <RewriteButtonContext.Provider
      value={{
        activeFieldId,
        setActiveField,
        registerField,
        unregisterField,
      }}
    >
      {children}
    </RewriteButtonContext.Provider>
  );
};

export const useRewriteButtonContext = () => {
  const context = useContext(RewriteButtonContext);
  if (!context) {
    throw new Error('useRewriteButtonContext must be used within RewriteButtonProvider');
  }
  return context;
};
